/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function SearchIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.7559 14.255H14.9659L14.6859 13.985C15.6659 12.845 16.2559 11.365 16.2559 9.755C16.2559 6.165 13.3459 3.255 9.75586 3.255C6.16586 3.255 3.25586 6.165 3.25586 9.755C3.25586 13.345 6.16586 16.255 9.75586 16.255C11.3659 16.255 12.8459 15.665 13.9859 14.685L14.2559 14.965V15.755L19.2559 20.745L20.7459 19.255L15.7559 14.255ZM9.75586 14.255C7.26586 14.255 5.25586 12.245 5.25586 9.755C5.25586 7.26501 7.26586 5.255 9.75586 5.255C12.2459 5.255 14.2559 7.26501 14.2559 9.755C14.2559 12.245 12.2459 14.255 9.75586 14.255Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
